// export const colours = {
//     primaryDark: "#ea9d3f",
//     primary: "#e2753a",
//     primaryLight: "#f5c44b",
//     green: "#6fb657",
//     darkGrey: "#474848",
// };

import { disable } from "mixpanel-browser";

export const colours = {
    primaryDark: {
        main: "rgba(234, 157, 63, 1.0)",
        hover: "rgba(234, 157, 63, 0.8)"
    },
    primary: {
        main: "rgba(226, 117, 58, 1.0)",
        hover: "rgba(226, 117, 58, 0.8)"
    },
    primaryLight: {
        main: "rgba(245, 196, 75, 1.0)",
        hover: "rgba(245, 196, 75, 0.8)"
    },
    green: {
        main: "rgba(111, 182, 87, 1.0)",
        hover: "rgba(111, 182, 87, 0.8)"
    },
    darkGrey: {
        main: "rgba(71, 72, 72, 1.0)",
        hover: "rgba(0, 0, 0, 1.0)"
    },
    disabled: {
        main: "rgba(71, 72, 72, 0.5)",
        hover: "rgba(71, 72, 72, 0.5)"
    }
};